export default __webpack_public_path__ + "static/media/icon_generic_benefit.4f2c8fc7.svg";